import PageShell from '../layouts/PageShell'
import Navbar from '../features/Navbar'
import Footer from '../features/landing/Footer'
import TOS from './tosContent.js'

const Block = ({ block }) => {
  if (block.t === 'p') {
    return <p className="text-[15px] leading-[26px] text-brand-dark">{block.text}</p>
  }
  if (block.t === 'ul') {
    return (
      <ul className="list-disc pl-6 space-y-2 text-[15px] leading-[26px] text-brand-dark">
        {block.items.map((it, i) => (
          <li key={i}>{it}</li>
        ))}
      </ul>
    )
  }
  return null
}

const Terms = () => {
  return (
    <PageShell>
      <Navbar />

      <section className="bg-brand-pageFill pt-[80px] pb-[120px]">
        <div className="max-w-[900px] mx-auto px-6 flex flex-col gap-8">
          <div className="flex flex-col gap-3 text-center">
            <h1 className="text-[40px] md:text-[48px] leading-[48px] md:leading-[56px] tracking-[-1px] font-extrabold text-brand-dark">
              {TOS.header}
            </h1>
            <p className="text-[14px] text-brand-dark/70">{TOS.updated}</p>
          </div>

          {TOS.preamble.length > 0 && (
            <div className="flex flex-col gap-3 border-l-4 border-brand-primary pl-5 py-2 bg-white/40 rounded-r">
              {TOS.preamble.map((p, i) => (
                <p key={i} className="text-[15px] leading-[26px] text-brand-dark">
                  {p}
                </p>
              ))}
            </div>
          )}

          <div className="flex flex-col gap-8">
            {TOS.sections.map((sec) => (
              <section key={sec.num} className="flex flex-col gap-3">
                <h2 className="text-[20px] md:text-[22px] leading-[30px] font-bold text-brand-dark">
                  {sec.num}. {sec.title}
                </h2>
                <div className="flex flex-col gap-3">
                  {sec.blocks.map((b, i) => (
                    <Block key={i} block={b} />
                  ))}
                </div>
              </section>
            ))}
          </div>

          <p className="text-[13px] text-brand-dark/60 pt-4 border-t border-brand-fieldBdr">
            Questions about these Terms? Email{' '}
            <a className="text-brand-primary underline" href="mailto:support@reilm.io">
              support@reilm.io
            </a>
            .
          </p>
        </div>
      </section>

      <Footer />
    </PageShell>
  )
}

export default Terms
